{
  "name": "SH_HS 12-48: Subharmonics/Harmonics combined",
  "description": "Subharmonic and Harmonic partial rows from 12° to 48° mapped onto a four octave cycle. In this scale, the subharmonic row is placed below the harmonic one, so the small microtonal intervals lie in the centre of the keyboard range.",
  "scale": [
    "48/47",
    "48/46",
    "48/45",
    "48/44",
    "48/43",
    "48/42",
    "48/41",
    "48/40",
    "48/39",
    "48/38",
    "48/37",
    "48/36",
    "48/35",
    "48/34",
    "48/33",
    "48/32",
    "48/31",
    "48/30",
    "48/29",
    "48/28",
    "48/27",
    "48/26",
    "48/25",
    "48/24",
    "48/23",
    "48/22",
    "48/21",
    "48/20",
    "48/19",
    "48/18",
    "48/17",
    "48/16",
    "48/15",
    "48/14",
    "48/13",
    "48/12",
    "13/3",
    "14/3",
    "15/3",
    "16/3",
    "17/3",
    "18/3",
    "19/3",
    "20/3",
    "21/3",
    "22/3",
    "23/3",
    "24/3",
    "25/3",
    "26/3",
    "27/3",
    "28/3",
    "29/3",
    "30/3",
    "31/3",
    "32/3",
    "33/3",
    "34/3",
    "35/3",
    "36/3",
    "37/3",
    "38/3",
    "39/3",
    "40/3",
    "41/3",
    "42/3",
    "43/3",
    "44/3",
    "45/3",
    "46/3",
    "47/3",
    "48/3"
  ],
  "key_colors_mode": "manual",
  "short_description": "72-SHS_12to48",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "48",
    "47",
    "46",
    "45",
    "44",
    "43",
    "42",
    "41",
    "40",
    "39",
    "38",
    "37",
    "36",
    "35",
    "34",
    "33",
    "32",
    "31",
    "30",
    "29",
    "28",
    "27",
    "26",
    "25",
    "24",
    "23",
    "22",
    "21",
    "20",
    "19",
    "18",
    "17",
    "16",
    "15",
    "14",
    "13",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48"
  ],
  "note_colors": [
    "#ff9898",
    "#f4b0d1",
    "#8fbd94",
    "#f6f2db",
    "#9fe48c",
    "#c19f70",
    "#ecc5c7",
    "#ec9684",
    "#f6f2db",
    "#decef5",
    "#ceeef6",
    "#c6dad9",
    "#ffffff",
    "#eecbc9",
    "#c6c6c6",
    "#9fe48c",
    "#ffffff",
    "#65e7e0",
    "#f6f2db",
    "#84a8f4",
    "#ecc5c7",
    "#ffffff",
    "#decef5",
    "#efe9d2",
    "#ffffff",
    "#8fbd94",
    "#9fe48c",
    "#ecc5c7",
    "#f6f2db",
    "#ceeef6",
    "#ffffff",
    "#c6c6c6",
    "#ffffff",
    "#f6f2db",
    "#ecc5c7",
    "#decef5",
    "#ffffff",
    "#e6d7fe",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#cfcfcf",
    "#ffffff",
    "#d6f7ff",
    "#fffae5",
    "#ffe5e5",
    "#dfffd6",
    "#95c69b",
    "#ffffff",
    "#fef5be",
    "#e6d7fe",
    "#ffffff",
    "#ffe5e5",
    "#8aafff",
    "#fffae5",
    "#68f3ec",
    "#ffffff",
    "#dfffd6",
    "#cfcfcf",
    "#ffcba8",
    "#ffffff",
    "#cee3e2",
    "#d6f7ff",
    "#e6d7fe",
    "#fffae5",
    "#f89b87",
    "#ffe5e5",
    "#c9a573",
    "#dfffd6",
    "#fffae5",
    "#95c69b",
    "#ffb8da"
  ],
  "equivSteps": 72,
  "fundamental": 240,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 38,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
